import { IAudioMedia } from "@types";
import { BaseAPI } from "@utils";

class AudioMediaApi extends BaseAPI<IAudioMedia> { }
export const audioMediaApi = new AudioMediaApi("/api/v1/media/audio");
